import {
  $adminsTableSearchInputValue,
  AdminsTable,
  AdminsTableGate,
  adminsTableQuery,
  adminsTableSearchChanged,
} from '@/entities/admins'
import { STRINGS } from '@/shared/config'
import {
  ContentWrapper,
  EmptyContent,
  HeaderContent,
  HidingSpin,
} from '@/shared/ui'
import { PrimaryButton } from '@/shared/ui'
import { AdminForm } from '@/widgets/AdminForm'
import { adminFormModalOpened } from '@/widgets/AdminForm'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Flex, Input } from 'antd'
import { useUnit } from 'effector-react'

import {
  $adminsListPageLatestFilters,
  $adminsListPageLatestPage,
  $adminsListPageLatestPageSize,
  $adminsListPageLatestSearch,
  $adminsListPageLatestSort,
  AdminsListPageGate,
} from './model/admins-list.model'

export function AdminsListPage() {
  const { data, pending, error } = useUnit(adminsTableQuery)

  const search = useUnit($adminsTableSearchInputValue)
  const changeSearch = useUnit(adminsTableSearchChanged)
  const latestSearch = useUnit($adminsListPageLatestSearch)
  const latestSort = useUnit($adminsListPageLatestSort)
  const latestFilters = useUnit($adminsListPageLatestFilters)
  const latestPage = useUnit($adminsListPageLatestPage)
  const latestPageSize = useUnit($adminsListPageLatestPageSize)

  const openAdminFormModal = useUnit(adminFormModalOpened)

  return (
    <>
      <AdminsListPageGate />
      <AdminsTableGate
        initialFilters={latestFilters}
        initialPage={latestPage}
        initialPageSize={latestPageSize}
        initialSort={latestSort}
        initialSearch={latestSearch}
      />
      <AdminForm isModal />
      <HeaderContent
        title="Администраторы"
        description="Здесь можно создавать, редактировать и удалять администраторов"
        buttonSlot={
          <PrimaryButton
            onClick={() => openAdminFormModal()}
            icon={<PlusOutlined />}
          >
            Добавить
          </PrimaryButton>
        }
      />
      <ContentWrapper>
        <Flex justify="end" align="center" style={{ marginBottom: 8 }}>
          <Input
            placeholder={STRINGS.placeholder_search_by_name_input}
            allowClear
            addonAfter={<SearchOutlined />}
            value={search || ''}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const searchString = event.target.value
              changeSearch(searchString)
            }}
            style={{
              maxWidth: 300,
            }}
          />
        </Flex>
        <HidingSpin spinning={pending || (!data?.items && !error)}>
          {data?.items && data.items.length > 0 ? (
            <>
              <AdminsTable
                onEdit={(adminId: string) => {
                  openAdminFormModal({ id: adminId })
                }}
              />
            </>
          ) : search?.length && search?.length > 0 ? (
            <EmptyContent description={STRINGS.nothing_was_found} />
          ) : (
            <EmptyContent />
          )}
        </HidingSpin>
      </ContentWrapper>
    </>
  )
}
